module.exports = __webpack_public_path__ + "img/dantdm.82198aa5.png";